export function merge(...args) {
  const result = {}

  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val)
    } else {
      result[key] = val
    }
  }

  args.forEach(arg => {
    if (typeof arg !== 'undefined') {
      if (typeof arg !== 'object' || Array.isArray(arg)) {
        throw new Error('[Http Exception] config must be a plain object')
      }

      for (const key in arg) { // eslint-disable-line no-restricted-syntax
        if (arg.hasOwnProperty(key)) { // eslint-disable-line no-prototype-builtins
          assignValue(arg[key], key)
        }
      }
    }
  })

  return result
}

export function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData)
}

export function isNumber(value) {
  return typeof value === 'number'
}
